import {z} from "zod/v4-mini"
import type {TemplateNode} from "#template/template-node/template-node"
import type {TemplateListNode} from "#template/template-list-node/template-list-node"

export const switchNodeParameters = <ItemType extends TemplateNode>(itemSchema: z.ZodMiniType<TemplateListNode<ItemType>, TemplateListNode<ItemType>>) =>
    z.object({
        name: z.string(),
        nodes: itemSchema,
    })
